const SSO_CONSTANTS = Object.freeze({
    SSO_TEST_INPROGRESS: "SSO Configuration Test Inprogress",
    AUTHORIZATION_VALIDATION_INPROGRESS: "Authorization Endpoint Validation Inprogress",
    AUTHORIZATION_VALIDATION_SUCCESS: "Authorization Endpoint Validation Success",
    TOKEN_VALIDATION_INPROGRESS: "Token Endpoint Validation Inprogress",
    TOKEN_VALIDATION_SUCCESS: "Token Endpoint Validation Success",
    REVOKE_VALIDATION_INPROGRESS: "Revoke Token Endpoint Validation Inprogress",
    REVOKE_VALIDATION_SUCCESS: "Revoke Token Endpoint Validation Success",
    LOGOUT_VALIDATION_INPROGRESS: "Logout Endpoint Validation Inprogress",
    LOGOUT_VALIDATION_SUCCESS: "Logout Endpoint Validation Success",
    SSO_TEST_SUCCESS: "SSO Server Test Success",
    SSO_TEST_FAILED: "SSO Server Test Failed",
    REVOKE_AND_LOGOUT_INVALID: "Revoke Endpoint URL or Logout Endpoint URL are Invalid",
    LABLE: {
        CLIENT_ID: "Client Id",
        WEB_REDIRECT_URI: "Web Redirect URI",
        ANDROID_REDIRECT_URI: "Android Redirect URI",
        PASSCODE: "Passcode",
        AUTHORIZATION_ENDPOINT_URL: "Authorization Endpoint URL",
        TOKEN_ENDPOINT_URL: "Token Endpoint URL",
        USERINFO_ENDPOINT_URL: "UserInfo Endpoint URL",
        INTROSPECTION_URL: "Introspection URL",
        REVOKE_ENDPOINT_URL: "Revoke Endpoint URL",
        LOGOUT_ENDPOINT_URL: "Logout Endpoint URL",
        ROLE_PARAM: "Role Param",
        USER_NAME_PARAM: "User Name Param",
        AUTHORIZATION_SCOPE: "Authorization Scope",
    },
    PLACEHOLDER: "Enter the {var1}",
    REQUIRED: "{var1} is required.",
    VALID_INPUT: "A valid {var1} is required.",
    INVALID_INPUT_LENGTH: "Invalid input! {var1} field supports maximum {var2} characters",
    HEADING: {
        SSO: "Single Sign On Server Configuration",
        ENTER_REQUIRED_INFO_TEST: "Enter the required information below and then click TEST SSO",
        SSO_ACTIVATION_STATUS: "SSO Activation Status",
        CURRENTLY_USING_SSO: "You are currently using Device Tracker built Authentication.",
        WOULD_YOU_LIKE_ACTIVATE: " Would you like to configure Single Sign On?",
        WEB_PORTAL: "Web Portal",
        DEVICE_TRACKER_APP: "Device Tracker App",
        ENTERPRISE_LOGIN_SCREEN_APP: "Enterprise Login Screen App",
        CONFIGURE_THIS_ENABLE_CHECK_IN: "Please configure this if check-in/check-out is enabled",
        SSO_ENDPOINT_URLS: "SSO Endpoint URLs",
        SSO_ENDPOINT_PARAMETERS: "SSO End point parameters"
    },
    SSO_PROVIDERS: {
        NONE:0,
        PING_FRED:1,
        AZURE:2
    },
     CLIENT_AUTH_TYPE :{
        NONE : 0,
        CLIENT_SECRET: 1,
        PRIVATE_KEY_JWT: 2,
        TLS: 3,
    }
});

//EOD Snapshot report categories
const EOD_CATEGORIES = Object.freeze({
'TO BE FOUND' : 'To Be Found',
'AT RISK' : 'At Risk',
'BEING FOUND' : 'Being Found',
'FOUND' : 'Found',
'CANNOT FIND' : 'Cannot Find',
'CHARGING' : 'Charging',
'DISCHARGING' : 'Discharging',
'LOW BATTERY' : 'Low battery' ,
'IDLE' : 'Idle',
'CHECKED OUT' : 'Checked out',
'DISCONNECTED' : 'Disconnected',
'NEVER CONNECTED' : 'Never Connected',
'DECOMMISSIONED' : 'Decommissioned',
'MOVEINOUT':"Move In/Out",
'CONNECTED ACCESSORIES':"Connected Accessories"
})

const EOD_CATEGORIES_TYPE = Object.freeze({
    'DEFAULT' : 'Default',
    'INCLUDE_ALL' : 'All'
    })

const sc = (str, replacing_object) => {
    for (let key in replacing_object) {
        str = str.replace("{" + key + "}", replacing_object[key]);
    }
    return str;
}

const SSO_STATUS_CONSTANTS = Object.freeze({
    SSOTESTSTATUS: {
        PROGRESS: 0,
        SUCCESS: 1,
        FAILED: 2
    },
    SSOTESTSTEPSTATUS: {
        AUTHORIZATION: 0,
        TOKEN: 1,
        REVOKE_AND_LOGOUT: 2,
        ALL_SUCCESS: 3
    }
});

const DEVICE_CHECKIN_OPTIONS_CONST = Object.freeze({
    MANUAL: 1,
    DEVICE_CRADLE: 1 << 1,
    DEVICE_REBOOT: 1 << 2,
    DEVICE_API: 1 << 3
})

const AUTOMATION_RULES = Object.freeze({
    MANUAL:"manually",
    DISCONNECTED: "Disconnection",
    disconnected: "Disconnection",
    MAX_CHECKOUT:"maxCheckout",
    IDLE:"idle",
    LOW_BATTERY:"lowBattery",
    NOT_CHARGING:"notCharging",
    CHECKED_OUT_LOW_BATTERY_NOT_CHARGING:'Checked out, low battery and not charging',
    CHECKED_OUT_LOW_BATTERY_NOT_CHARGING_IDLE:'Checked out, low battery, not charging and idle',
    CHECKED_OUT_MAX_TIMEOUT_REACHED:"Checked out and maximum checkout time reached",
    CHECKED_IN_LOW_BATTERY_NOT_CHARGING:"Checked in, low battery and not charging",
    LOW_BATTERY_NOT_CHARGING:"Low battery and not charging",
    LOW_BATTERY_IDLE_NOT_CHARGING:"Low battery, idle and not charging",
    IDLE_NOT_CHARGING:"Idle and not charging"
})

const DLR_MACHINE_LEARNING = Object.freeze({
    ML_PREDICTION_STATUS: {
        ENABLE: 1,
        DISABLE: 0,
        DISABLE_IN_PROGRESS:2,
        ENABLE_IN_PROGRESS: 3
    },
    READY_STATUS: {
        0: { text: "Processing devices", color: "#6d7380" },
        1: { text: "Learning", color: "#b2731c" },
        2: { text: "Ready", color: "#088853" },
        3: { text: "Active", color: "#1d81e7"},
        4: { text: "Deactive", color: "#e03d4d" },
        999: { text: "N/A", color: "black" },
        3999: { text: "Activation In Progress..", color: "#1d81e7" },
        4999: { text: "Deactivation In Progress..", color: "#e03d4d" },
    },
    READY_STATUS_VALUES: {
        ACTIVATION_PROGRESS: 3999,
        DEACTIVATION_PROGRESS: 4999,
        NA: 999,
        PROCESSING: 0,
        LEARNING: 1,
        READY: 2,
        ACTIVE: 3,
        DEACTIVE: 4
    },
    ACTIVATION_STATE: {
        0: { text: "Activate", color: "primary" },
        1: { text: "Deactivate", color: "secondary" },
        2: { text: "Activate", color: "primary" },
    },
    ACTIVATION_STATE_VALUES: {
        ACTIVE: 1,
        NOT_ACTIVE: 0,
        DEACTIVE: 2,
    },
    ENROLL_STATUS_VALUES: {
        ENROLLED: 1
    },
    DLR_ENROLL_STATUS: {
        0:  'Unenrolled',
        1:  "Enrolled",
        2:  "Enrolled Failed",
        3:  "Unenrolled Failed",
    },
    DLR_ISSUE: {                               // ZDS Status/Issue
        1: "Active",
        2: "Not Configured",
        3: 'Failed',
    },
    BULK_RETRY_CONFIG_STATUS: {
        RETRY_FAILED: 0,
        RETRY_INPROGRESS: 1,
        RETRY_SUCCESS: 2
    }
})

const NOTIFICATION_CONFIGURATION =Object.freeze({
    AUDIO_LIST: [
        "System Default",
        "Device Tracker Sound",
        "Use Sound File On Device"
    ],
    DEVICE_SOUND_LIST: [
        { label: "Device Tracker 1", value: "Device Tracker 1.mp3" },
        { label: "Device Tracker 2", value: "Device Tracker 2.mp3" },
        { label: "Device Tracker 3", value: "Device Tracker 3.mp3" },
        { label: "Device Tracker 4", value: "Device Tracker 4.mp3" },
        { label: "Device Tracker 5", value: "Device Tracker 5.mp3" }
    ],
    VOLUME_LEVEL_LIST: [
        { label: "20%",  value: 20 },
        { label: "40%",  value: 40 },
        { label: "60%",  value: 60 },
        { label: "80%",  value: 80 },
        { label: "100%", value: 100 }
    ],
    REPEAT_INTERVAL: [
        // { label: "None",   value: 0  },
        { label: "1 min",  value: 1 },
        { label: "2 min",  value: 2 },
        { label: "5 min",  value: 5 },
        { label: "10 min", value: 10 },
        { label: "20 min", value: 20},
        { label: "30 min", value: 30 }
    ],
    VIBRATE_OPTION: [
        { label: "System default", value: 0 },
        { label: "Short", value: 1 },
        { label: "Medium", value: 2 },
        { label: "Long", value: 3 }
    ],
    NOTIFICATION: {
        0: false,
        1: true,
        ENABLE: 1,
        DISABLE: 0
    },
    DEFAULT_VALUES: {
        TIMEOUT_DURATION: 15,
        TIMEOUT_DURATION_MAX: 120,
        TIMEOUT_DURATION_MIN: 5,
        LOCK_AFTER_TIMEOUT: 1,
        BLOCKED_SCREEN_MESSAGE: 'Hello, your device is "At Risk" and may be considered lost.',
        MESSAGE: "Hello, are you still with me?",
        LOCK_MESSAGE: "This device will be locked in:",
        MESSAGE_MAX_LENGTH: 128,
        AUDIO_NOTIFICATION: 1,
        AUDIO_TONE: 0, 
        AUDIO_ON_DEVICE: "Device Tracker 1.mp3",
        CUSTOM_TONE: "",
        CUSTOM_TONE_MAX_Length: 28,
        VOLUME_LEVEL: 100,
        LED_NOTIFICATION: 1,
        VIBRATE_NOTIFICATION: 1,
        VIBRATE_DURATION: 2,
        VIBRATE_DURATION_JSON: { label: "Medium", value: 2 },
        REPEAT_DURATION:1,
        REPEAT_DURATION_MIN:1
    }
})

const USER_TYPE = Object.freeze({
    SSO:1,
    NON_SSO:0
})


module.exports = {
    SSO_CONSTANTS,
    SSO_STATUS_CONSTANTS,
    sc,
    DEVICE_CHECKIN_OPTIONS_CONST,
    DLR_MACHINE_LEARNING,
    NOTIFICATION_CONFIGURATION,
    EOD_CATEGORIES,
    EOD_CATEGORIES_TYPE,
    AUTOMATION_RULES,
    USER_TYPE
}


module.exports.CLIENT_AUTH_TYPE = Object.freeze({
    NONE : 0,
    CLIENT_SECRET: 1,
    PRIVATE_KEY_JWT: 2,
    TLS: 3,
})

module.exports.GPS_SETTINGS = Object.freeze({
    MIN: 5*60,
    MAX: 24*60*60,
    DEFAULT: 5*60,
})



/*
    Below JSON is used to define details for column preferences, it have the information like DB_NAME, DEFAULT_COLUMN_LIST, DEFAULT_SELECTED, COLUMN_LABEL_MAPPING
    DB_NAME:- This field is used to store data in session and firestore
    DEFAULT_COLUMN_LIST:- Column list in rearrange popup are displayed from this field.
    DEFAULT_SELECTED:- If nothing is saved in db, then this is default columns are selected.
    COLUMN_LABEL_MAPPING:- used to map the db field name and display label

    DEVICE_DASHBOARD:- This defined the Page, for which we are using the Column Rearrange feature and this key is passed as props in columnRearrangePopup
*/
module.exports.COL_PREFERENCES = {
    DEVICE_DASHBOARD: {
        DB_NAME:"DeviceDash",
        DEFAULT_COLUMN_LIST: [ 
            "friendlyName",
            "displaySerialNumber",
            "modelNumber",
            "siteName",
            "accessory",
            "gpsLocation",
            "apFriendlyName",
            "userId",
            "checkInUser",
            "deviceStateName",
            "connectionState",
            "batteryLevel",
            "isCharging",
            "checkedInAt",
            "checkedOutAt",
            "reportedAt",
            "enrolmentStatus",
            "enrolmentDate",
            "zdsStatus"
        ],
        DEFAULT_SELECTED: [
            "friendlyName",
            "displaySerialNumber",
            "modelNumber",
            "siteName",
            "accessory",
            "gpsLocation",
            "apFriendlyName",
            "userId",
            "checkInUser",
            "deviceStateName",
            "connectionState",
            "batteryLevel",
            "isCharging",
            "checkedInAt",
            "checkedOutAt",
            "reportedAt",
            "enrolmentStatus",
            "enrolmentDate",
            "zdsStatus"
        ],
        COLUMN_LABEL_MAPPING: {
            "friendlyName":"Device Name",
            "displaySerialNumber": "Serial #",
            "modelNumber" : "Device Model",
            "userId" : "Checked Out By",
            "checkInUser":"Last User",
            "gpsLocation": "Map View",
            "apFriendlyName" : "Location",
            "deviceStateName" : "Status",
            "connectionState" : "Connection",
            "batteryLevel" : "Battery %",
            "isCharging" : "Charging",
            "siteName" : "Site",
            "checkedInAt":"Last Check In" ,
            "checkedOutAt": "Checked Out At",
            "reportedAt":"Last Reported",
            "enrolmentStatus": "Enrolment Staus",
            "enrolmentDate": "Enrolment Date",
            "zdsStatus": "Zebra Data Services Status",
            "accessory" : "Accessory"
            
        }
    }
}


module.exports.FILTER_CONSTANT = {
    INITIAL_OPTION_LOADED: 10,
    MAX_OPTION_SELECT: 10
}

module.exports.getEodCategories = (isBtScannerEnabled) => {
    let categoriesData = ['Never Connected','Disconnected','Checked Out','Low Battery','Charging',
        'Decommissioned','Discharging','Idle','At Risk',
        'To Be Found','Being Found', 'Cannot Find','Found',
        EOD_CATEGORIES.MOVEINOUT
    ]
    
    if(isBtScannerEnabled === true){
        categoriesData.push(EOD_CATEGORIES["CONNECTED ACCESSORIES"])
    }
    
    categoriesData = categoriesData.map(element=>{
        if(element === EOD_CATEGORIES.MOVEINOUT){
            return {label:'Moved Out/In Site(s)',value:element}
        }
        return {label:element,value:element}
    }).sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    categoriesData = [{label:'Select All',value:"Select All"}].concat(categoriesData)
    return categoriesData;
}

module.exports.DEVICE_STATES = Object.freeze({
    0:"In Service",
    1:"To Be Found",
    2:"Being Found",
    3:"Found",
    4:"Not Found",
    9999:"Decommissioned"
    
})

module.exports.CONNECTION_STATES = Object.freeze({
    0:"Never Connected",
    1:"Connected",
    2:"Not Connected"
})

module.exports.DEVICE_MOMENT_CATEGORIES = Object.freeze({
    MOVED_IN : 'Moved In',
    MOVED_OUT: 'Moved Out'
})

module.exports.DEFAULT_TIMESTAMP_TZ = Object.freeze({
    DEFAULT_TZ : 'UTC'
})

module.exports.PRODUCTIVITY_CONSTANT = {
    lostLabeling : "avgLost",
    foundLabeling :"avgFound",
    timeTakenToLost : "avgLostTime",
    timeSpendToFind :"avgTimeSpendToFind",
    totalLost :"totalLost",
    totalFound : "totalFound",
}

module.exports.DEVICELIST_CONSTANT = {
    licenseNotAvailable: "Licence not available."
}